import { useSelector } from 'react-redux';
import { Button, SectionAlert, Surface, Txt } from '@vst/beam';
import { Router } from '@vst/beam-icons/icons';
import { useTranslation } from 'react-i18next';

import { selectSsid } from '@app/redux/network';

import styles from '../styles.module.scss';

type HomeNetworkProps = {
  onEditClick: () => void;
};

type InfoRowProps = {
  label: string;
  children: React.ReactNode;
};

const InfoRow = ({ label, children }: InfoRowProps) => (
  <Surface className={styles['infoRow']} py={'24px'}>
    <Txt variant="bodyLargeRegular" color="regular">
      {label}
    </Txt>
    {children}
  </Surface>
);

export const HomeNetwork = ({ onEditClick }: HomeNetworkProps) => {
  const { t } = useTranslation('Network');
  const { ssidName, ssidLoading } = useSelector(selectSsid);

  return (
    <Surface p={{ sm: '24px', md: '40px' }} className={styles['headerContainer']}>
      <Txt variant={'heading5'} pb={'24px'}>
        {t('networkManagement.wifiNetworkLabel')}
      </Txt>

      <InfoRow label={t('networkManagement.networkNameLabel')}>
        {ssidLoading ? (
          <div className={styles['skeleton']} />
        ) : (
          <Txt variant="bodySmallRegular">{ssidName ?? t('networkManagement.ssidUnavailable')}</Txt>
        )}
      </InfoRow>
      <div className={styles['divider']} />

      <Surface className={styles['infoRow']} pt={'24px'}>
        <Txt variant="bodyLargeRegular" color="regular">
          {t('networkManagement.networkPasswordLabel')}
        </Txt>
        <Txt variant="bodySmallRegular">{t('networkManagement.hiddenPassword')}</Txt>
      </Surface>
      <Txt variant="smallRegular" color="subtle" mt="8px" mb="56px">
        {t('networkManagement.wifiHelperText')}
      </Txt>
      <div className={styles['divider']} />

      <div
        className={styles['divider']}
        style={{
          marginInline: 'calc(var(--beam--component-x-paddings) * -1.5)',
        }}
      />

      <Button
        variant="primary"
        onClick={onEditClick}
        data-cy="change-wifi-info-btn"
        className={styles['editButton']}
        mt={{ xs: '24px', md: '40px' }}
      >
        {t('networkManagement.wifiChangeDetails')}
      </Button>
    </Surface>
  );
};
